//React
import { FunctionComponent, useEffect } from "react";

//Selectors
import {
	useAppDispatch,
	useAppSelector,
} from "../../system/redux/hooks/redux-store-hooks";
import { selectAreaInfo } from "../redux/selectors/select-area-info";
import { selectAvailableHomeCount } from "../../results/redux/selectors/select-available-home-count";
import { selectIsMobile } from "../../system/redux/selectors/select-is-mobile";
import { selectIsAnchorClicked } from "../../system/redux/selectors/select-is-anchor-clicked";
import { selectIsQmiFinder } from "../../system/redux/selectors/select-is-qmi-finder";
import { setIsQmiFinder } from "../../system/redux/slices/app-status-slice";
import { setFirstSearchComplete } from "../../system/redux/slices/app-status-slice";
import { selectIsFirstSearchComplete } from "../../system/redux/selectors/select-first-search-complete";
import { setIsAnchorClicked } from "../../system/redux/slices/app-status-slice";
import { selectIsMobileCardOpen } from "../../system/redux/selectors/select-is-mobile-card-open";
import { setIsMobileCardOpen } from "../../system/redux/slices/app-status-slice";
import { setSelectedResult } from "../../results/redux/slices/result-list-slice";

//Util
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";
import { selectRadiusInMiles } from "../redux/selectors/select-radius-in-miles";
import { selectRteApiData } from "../../results/redux/selectors/rte/select-rte-api-data";
import { selectAreaIsState } from "../../area-info/redux/selectors/select-area-is-state";

interface AreaNewHomeCountProps {}

const AreaNewHomeCount: FunctionComponent<AreaNewHomeCountProps> = (props) => {
	const dispatch = useAppDispatch();
	const isMobile = useAppSelector(selectIsMobile);
	const isAnchorClicked = useAppSelector(selectIsAnchorClicked);
	const isQmiFinder = useAppSelector(selectIsQmiFinder);
	const isFirstSearchComplete = useAppSelector(selectIsFirstSearchComplete);
	const isMobileCardOpen = useAppSelector(selectIsMobileCardOpen);
	const areaInfo = useAppSelector(selectAreaInfo);
	const availableHomeCount = useAppSelector(selectAvailableHomeCount);
	const radiusInMiles = useAppSelector(selectRadiusInMiles);
	const rteStatus = useAppSelector(selectRteApiData);
	const areaIsState = useAppSelector(selectAreaIsState);


	const mobileCardOpenStyling = {
		display: isMobileCardOpen ? "none" : "block",
	};

	var homesText = availableHomeCount !== 1 ? "homes" : "home";
	homesText += isQmiFinder ? " of the week" : "";
	const mobileCommHomesText = availableHomeCount !== 1 ? "homes for sale" : "home for sale";

	//Functions
	function getMobileHomeCountText() {
		return availableHomeCount + " homes for sale";
	}
	
	const normalizePretty = (input: string, maxLength = 25): string => {
		if (input.length <= maxLength) return input;
		const trimmed = input.substring(0, maxLength - 3).trimEnd();
		return trimmed + "...";
	};

	const isCommunitySelected = isQmiFinder ? '' : 'selected';
	const isQmiSelected = isQmiFinder ? 'selected' : '';

	function anchorClicked() {
		if (isAnchorClicked == true) {
			dispatch(setIsAnchorClicked(false));
		} else {
			dispatch(setIsAnchorClicked(true));
		}
	}

	
	const handleClick = (tabValue: boolean) => {
		// only run functions if tab click is changing isQmiFinder's value
		if (tabValue !== isQmiFinder) {
			// reset the firstSearchComplete state to false
			// so it can be re-set to true when the related API finishes loading
			dispatch(setFirstSearchComplete(false));
			
			// set is QMI Finder to true or false
			dispatch(setIsQmiFinder(tabValue));

			//close info window if open
			dispatch(setIsMobileCardOpen(false));
			dispatch(setSelectedResult(null));
		}
	}

	//JSX
	if (isMobile) {
		return (
			<>
				<div className="tab-anchor">
					{rteStatus.status !== "live" &&  isFirstSearchComplete &&
						<>
							{!areaIsState ? <div className="hotw-tabs hotw-tabs-mobile">
								<button onClick={() => handleClick(false)} className={isCommunitySelected} id="communityTab">Communities</button>
								<button onClick={() => handleClick(true)} className={isQmiSelected} id="qmiTab">Homes of the week</button>
							</div> : <div className="hotw-tabs hotw-tabs-mobile">
								<button onClick={() => handleClick(false)} className={isCommunitySelected} id="communityTab">Communities</button>
							</div>}
						</> 
					}
					<div
						className={ isAnchorClicked ? "area-info-anchor-down" : "area-info-anchor-up"}
						id="area-info-anchor"
						style={mobileCardOpenStyling}
						onClick={anchorClicked}
					></div>
				</div>
				{!isQmiFinder && <p className="comm-tab-homes-text">{availableHomeCount} {mobileCommHomesText}</p>}
			</>
		);
	}

	if (!isMobile) {
		if (isStringEmpty(areaInfo?.Name)) {
			return (
				<h1 className="top-results_Count">
					<span>{availableHomeCount}</span> new {homesText} for sale in this area
				</h1>
			);
		} else {
			return (
				<h1 className="top-results_Count">
					<span>{availableHomeCount}</span> new {homesText} for sale within{" "}
					{radiusInMiles} miles of <span className="areaInfoTitleCount" title={(areaInfo?.Name)}>{normalizePretty(areaInfo?.Name)}</span>
				</h1>
			);
		}
	}
};

export default AreaNewHomeCount;
